
import React, { useState, useContext, useEffect, useRef } from "react";

import { SidebarData } from "./SidebarData.jsx";
import SubMenu from "./SubMenu";
import "./Navbar.css";
import NavContext from "../Context/NavContext";
import axios from "axios";
import { Cookies } from "react-cookie";
import Loading from "../components/Loading.jsx";

function Navbar() {
  const cookies = new Cookies();
  const token = cookies.get("JWTcookie");
  const { sidebar } = useContext(NavContext);
  const [navData, setNavData] = useState({});
  const [userRole, setUserRole] = useState("");

  // "http://localhost:3000/api/Permission/LoadMenu",
  const baseUrl =process.env.REACT_APP_BASE_URL;
  const loadDate = async () => {
    try {
      const response = await axios.get(
        `${baseUrl}/api/Permission/LoadMenu`,
        { headers: { Authorization: "Bearer " + token } }
      );
   
      setUserRole(response.data.data.role);
      setNavData(response.data);
    } catch (error) {
      console.log(error);
    }
  };

// const loadDate = async () => {
//       const response = await getReq(`${path}`);
//       if(response.success){
//         setUserRole(response.data.role);
//         setNavData(response.data);
//       }
//   };

  // console.log('NavData:', navData)
const loadDateRef=useRef(loadDate);
  useEffect(() => {
    loadDateRef.current();
  }, []);

  const userName = localStorage.getItem("username");
  return (
    <React.Fragment>
      <nav className={sidebar && "nav-menu active"}>
        <ul className="nav-menu-items">
          <li>
            <div className="userinfo-container">
              <h4>Welcome</h4>
              <h3>
                {userRole?.toUpperCase()}
                <p style={{ color: "grey" }}>{`(${userName})`}</p>
              </h3>
            </div>
            <hr style={{ borderColor: "grey" }}></hr>
            {navData.data ? (
              SidebarData?.map((item, index) => 
                navData.data[item.permission] ? 
               (<SubMenu
                    item={item}
                    key={index}
                    indexValue={index}
                    navData={navData.data}
                  />
                  ):('')
                
                // ) : (
                //   ""
              )
            )
               : (
                <div
                  style={{
                    top: "70px",
                    margin: "auto",
                    display: "flex",
                    position: "relative",
                  }}
                >
                  {" "}
                  <Loading />{" "}
                </div>
               )
            }
          </li>
        </ul>
      </nav>
    </React.Fragment>
  );
}

export default Navbar;